<app-page-header
  [title]="'Política de privacidad'"
  [breadcrumbs]="breadcrumbs"
></app-page-header>

<section class="w-full h-auto
  py-10 md:py-10 lg:py-10 xl:py-24 2xl:py-20
  px-5 3xl:px-[295px] 2xl:px-[120px] xl:px-[45px] md:px-28
">
  <div class="flex flex-col gap-8">
    @if (policyHtml() != null) {
      <h1 class="text-4xl font-bold font-heading text-heading-primary text-center">{{ planTitle() }}</h1>
      <div [innerHTML]="policyHtml()" class="policy-content wrap-break-word"></div>
    }
  </div>
</section>